import React from "react";
import { translate } from "../../common/localization";
import "./index.css";

const thankYouPage = () => (
  <div className="thank-you-page">
    <div className="thank-you-page-message">
      <h1>{translate('thankyouPage.message1')}</h1>
      <h2>{translate('thankyouPage.message2')}</h2>
      <h3>{translate('thankyouPage.message3')}</h3>
      <a href="https://gskdestinystudy.com">
      {translate('thankyouPage.learnMore')}
      </a>
    </div>
    <footer>
      <div className="links">
        <a href="https://www.studykik.com">{translate('thankyouPage.createdByStudyKIK')}</a>

        <a href="https://studykik.com/privacy-policy">
          {translate('thankyouPage.privacyPolicy')}
        </a>
        <a href="https://www.gsk.com/">{translate('thankyouPage.GSKHomePage')}</a>
      </div>

      <p>{translate('thankyouPage.sponsoredByGSK')}</p>
      <p>{translate('thankyouPage.webId')}</p>
    </footer>
  </div>
);

export default thankYouPage;
